function showTable(tableId) {

  document.querySelectorAll('.tab-content').forEach(table => {
    table.classList.remove('active');
  });


  document.querySelectorAll('.tab-button').forEach(button => {
    button.classList.remove('active');
  });


  document.getElementById(tableId).classList.add('active');
  document.querySelector(`.tab-button[data-target="${tableId}"]`).classList.add('active');


  const dataTableElement = document.querySelector(`#${tableId} table`);
  if (dataTableElement && $.fn.DataTable.isDataTable(dataTableElement)) {
    $(dataTableElement).DataTable().columns.adjust().responsive.recalc();
  }
}

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.tab-content table').forEach(table => {
    $(table).DataTable({
      paging: true,
      pageLength: 5,         // Number of rows per page
      responsive: true,      // Enable responsive design
      searching: true,       // Enable the search box
      autoWidth: false,      // Adjust column width dynamically
      lengthChange: false,   // Remove "Show entries" dropdown
      language: {
        paginate: {
          previous: "«",
          next: "»"
        },
        search: "Search Table:",
        zeroRecords: "No matching records found"
      }
    });
  });

  // Show the first table by default
  const firstTable = document.querySelector('.tab-button.active')?.dataset.target || 'table1';
  showTable(firstTable);
});
